import { useEffect } from 'react';

import { UnreadNotificationCountDocument } from '@graphql/generated/graphql';

import { useCaseReportStatistics } from '@utils/hooks/useCaseReportStatistics';
import { useDisclosuresStatistics } from '@utils/hooks/useDisclosuresStatistics';
import { useSurveysStatistics } from '@utils/hooks/useSurveysStatistics';

import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export const useNotifications = () => {
    const auth = useReactiveVar(authVar);

    const [
        getUnreadNotificationCount,
        { data, previousData, startPolling, stopPolling },
    ] = useLazyQuery(UnreadNotificationCountDocument, {
        notifyOnNetworkStatusChange: true,
    });

    const { refetch: refetchCases } = useCaseReportStatistics({
        fetchPolicy: 'cache-and-network',
    });
    const { refetch: refetchSurveys } = useSurveysStatistics({
        fetchPolicy: 'cache-and-network',
    });
    const { refetch: refetchDisclosures } = useDisclosuresStatistics({
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        if (auth.isLoggedIn && !auth.isGuest) {
            void getUnreadNotificationCount();
            startPolling(5000);
        } else stopPolling();
    }, [auth]);

    useEffect(() => {
        if (previousData && data && data.amount !== previousData.amount) {
            void refetchCases();
            void refetchSurveys();
            void refetchDisclosures();
        }
    }, [data, previousData]);
};
